import { cn } from '@/lib/cn';

interface SpinnerProps {
  size?: 'xs' | 'sm' | 'md' | 'lg';
  colour?: 'current' | 'violet' | 'mint' | 'white';
  label?: string;
}

const sizeClasses = {
  xs: 'w-3 h-3',
  sm: 'w-4 h-4',
  md: 'w-5 h-5',
  lg: 'w-8 h-8',
};

const colourClasses = {
  current: 'text-current',
  violet: 'text-violet-400',
  mint: 'text-mint-400',
  white: 'text-white',
};

export const Spinner = ({ size = 'md', colour = 'current', label = 'Loading' }: SpinnerProps) => (
  <span role="status" aria-label={label} className={cn('inline-block', colourClasses[colour])}>
    <svg className={cn('animate-spin', sizeClasses[size])} viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeOpacity="0.25" strokeWidth="3" />
      <path
        d="M22 12a10 10 0 0 1-10 10"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
    <span className="sr-only">{label}</span>
  </span>
);

Spinner.displayName = 'Spinner';
